<ng-container *puLet="quantity$ | async as quantity">
  <div class="pu-cart-counter"
       *ngIf="quantity"
       [style.top]="top"
       [style.right]="right">
    {{quantity}}
  </div>
</ng-container>
